import React, { FC } from 'react';
import { LoginProps } from '@/components/Login/Login/Login.types';
import dynamic from 'next/dynamic';

const Login = dynamic(() => import('@/components/Login/Login/Login'), { ssr: false });
const BaseSetPassword = dynamic(() => import('@/components/Login/SetPassword/BaseSetPassword'), { ssr: false });
const PasswordResetLinkExpired = dynamic(() => import('@/components/Login/PasswordResetLinkExpired'), { ssr: false });

export type SetPasswordProps = { verified?: boolean } & LoginProps;

const SetPassword: FC<SetPasswordProps> = (props) => {
    const isVerified = props?.verified;

    return (
        <Login resetPassword={true} {...props}>
            {isVerified ? <BaseSetPassword /> : <PasswordResetLinkExpired />}
        </Login>
    );
};

export default SetPassword;
